import config from 'react-global-configuration'
import authAxios from './authAxios'
import env from '../env-config';

//// for multiple requests
let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    })

    failedQueue = [];
}

function createAuthRefreshInterceptor(axios) {

    const id = axios.interceptors.response.use(res => res, error => {
        const originalRequest = error.config
        if (error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject })
                }).then(token => {
                    originalRequest.headers['Authorization'] = 'Bearer ' + token
                    return axios(originalRequest)
                }).catch(err => {
                    return err
                })
            }
        }

        originalRequest._retry = true
        isRefreshing = true

        if (error.response.status !== 401) {
            return Promise.reject(error);
        }
        else {
            // Remove the interceptor to prevent a loop
            // in case token refresh also causes the 401
            //axios.interceptors.response.eject(id)

            return new Promise(function (resolve, reject) {
                authAxios.get("/auth/token").then((tokenRefreshResponse) => {

                    localStorage.setItem('SCGChem.PMM.WasteMgnt.WebUI.token', tokenRefreshResponse.data.access_token);

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.access_token
                    originalRequest.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.access_token

                    processQueue(null, tokenRefreshResponse.data.access_token)
                    resolve(axios(originalRequest))

                })
                    .catch((err) => {
                        processQueue(err, null);
                        reject(err);

                        sessionStorage.setItem("SCGChem.PMM.WasteMgnt.WebUI.RedirectUrl", window.location.href);
                        window.location = env.REACT_APP_API_BASE_URL + "/auth";
                    })
                    .then(() => { isRefreshing = false })
            })
        }
    });
    return axios;
}
export default createAuthRefreshInterceptor;
